import styled from "styled-components";

const AdLibraryHolder = styled.div`
  padding: 130px 0;
`;

export default AdLibraryHolder;
